import { observer } from 'mobx-react-lite';
import { Button } from '../../../buttons/button';
import { BasicLoader } from '../../../loaders/basic-loader';
import { PopupStore } from '../../popup.store';

export const PaymentPending = observer<{ popupStore: PopupStore; styles: { [key: string]: string } }>(({ popupStore, styles }) => {
  return (
    <>
      <h4 className="cust-my-4">Payment In progress</h4>

      <BasicLoader isLoading={true}>
        <></>
      </BasicLoader>

      <h5 className="cust-my-4">Status is: Pending</h5>
    </>
  );
});